// Copyright (c) 2021 David Chan
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import recent from '../assets/photos/landing/most recent.jpg';
import { Container, Image, Text, Group, ActionIcon, Stack, Box, Title, Anchor, Tooltip } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faAddressCard } from '@fortawesome/free-regular-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default function Landing(props) {
    return (
        <Box
            component="section"
            py={{ base: 'xl', md: 80 }}
            style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            <Container size="sm" px="md">
                <Stack gap="md" align="center">
                    <Image
                        src={recent}
                        alt="Paul H. Chan"
                        radius="lg"
                        w={{ base: 170, sm: 200 }}
                        fit="cover"
                    />

                    <Title order={1} size="h2" ta="center">
                        Paul H. Chan
                    </Title>

                    <Text size="lg" fw={500} ta="center">
                        Attorney, Executive, and Board Member
                    </Text>

                    <Text size="md" lh={1.6} ta="center" maw={620}>
                        More than 35 years of leadership experience in higher education, nonprofit
                        organizations, and government, with a longstanding commitment to inclusion,
                        integrity, community, and effective governance.
                    </Text>

                    <Text ta="center">
                        Contact: <Anchor href="mailto:paul@PaulHChan.com">paul@PaulHChan.com</Anchor>
                    </Text>

                    <Group justify="center" gap="xl" mt="xs">
                        <Tooltip label="LinkedIn">
                            <ActionIcon
                                component="a"
                                href="http://www.linkedin.com/in/paulhchan"
                                target="_blank"
                                rel="noopener noreferrer"
                                size="xl"
                                variant="subtle"
                                color="dark"
                                aria-label="LinkedIn">
                                <FontAwesomeIcon icon={faLinkedin} size="2x" />
                            </ActionIcon>
                        </Tooltip>

                        <Tooltip label="Email">
                            <ActionIcon
                                component="a"
                                href="mailto:paul@paulhchan.com"
                                size="xl"
                                variant="subtle"
                                color="dark"
                                aria-label="Email">
                                <FontAwesomeIcon icon={faEnvelope} size="2x" />
                            </ActionIcon>
                        </Tooltip>

                        <Tooltip label="Contact card">
                            <ActionIcon
                                component="a"
                                href="/paulchan.vcf"
                                size="xl"
                                variant="subtle"
                                color="dark"
                                aria-label="Contact card">
                                <FontAwesomeIcon icon={faAddressCard} size="2x" />
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                </Stack>
            </Container>
        </Box>
    );
}
